import React from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Switcher, SwitcherPill, SwitcherPillInactive} from "./AppModeSwitcherCollapsed.style";
import {Tooltip} from "../../cms/Tooltip";
import {DashboardIcon} from "../../../icons/DashboardIcon";
import {MenuIcon} from "../../../icons/MenuIcon";

export const AppModeSwitcherCollapsed = () => {
    const {t} = useTranslation();
    const {cmsActive} = useSelector(state => state.globalParams.globalParams);

    return (
        <Switcher>
            {cmsActive &&
                <Tooltip content={t('dashboard')} topOffset={-20}>
                    <SwitcherPillInactive $cmsActive={cmsActive}>
                        <DashboardIcon/>
                    </SwitcherPillInactive>
                </Tooltip>
            }
            <Tooltip content={cmsActive ? t('menu') : t('dashboard')} topOffset={-20}>
                <SwitcherPill $cmsActive={cmsActive}>
                    {cmsActive ? <MenuIcon fill={'#FFF'}/> : <DashboardIcon fill={'#FFF'}/>}
                </SwitcherPill>
            </Tooltip>
            {!cmsActive &&
                <Tooltip content={t('menu')} topOffset={-20}>
                    <SwitcherPillInactive $cmsActive={cmsActive}>
                        <MenuIcon/>
                    </SwitcherPillInactive>
                </Tooltip>
            }
        </Switcher>
    );
}